import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-auto-partial-invest',
    templateUrl: './auto-partial-invest.component.html',
    styleUrls: ['./auto-partial-invest.component.scss', '../../../../assets/styles/finzy-styles.scss']
})
export class AutoPartialInvestComponent {
    @Input()
    public readonly investmentAmount;

    @Input()
    public readonly remainingAmount;
}